import React from 'react' // eslint-disable-line no-unused-vars
import RowCard from './RowCard'

const DocumentsTableMobile = ({
    id,
    languageContent,
    isDownloading,
    columnNames,
    columnKeys,
    rows,
    showDownloadPopupModal,
    searchAuditId }) => {

    return (
        <React.Fragment>
            <div>
                {
                    rows.map((item, i) => {
                        const groupedData = item.groupedDocuments || [ item ]
                        const groupedCardStyle = item.groupedDocuments ? item.groupedCardStyle : {}
                        return (
                            <RowCard
                                key={`card-i-${groupedData[0].parent.id}`}
                                id={id}
                                index={i}
                                languageContent={languageContent}
                                groupedData={groupedData}
                                groupedCardStyle={groupedCardStyle}
                                columnNames={columnNames}
                                columnKeys={columnKeys}
                                showDownloadPopupModal={showDownloadPopupModal}
                                searchAuditId={searchAuditId}
                            />)
                    })
                }
            </div>
        </React.Fragment>
        
    )
}

export default DocumentsTableMobile


// WEBPACK FOOTER //
// ./src/mi-app/tables/DocumentsTableMobile.js